
import styles from '../style.module.css';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function NewsItem({ news }) {

    const { currentLanguage } = useSelector(({ main }) => main);
    const navigate = useNavigate();

    return (
        <div
            className={styles.news_item}
            onClick={() => navigate(`/blog/${news.slug}`)}
        >
            <div className={styles.news_item_image_box}>
                <img
                    src = {process.env.REACT_APP_STORAGE_URL + news["image_url_" + currentLanguage]}
                    alt = {'news image'}
                />
            </div>
            <p> { news['title_' + currentLanguage] } </p>
        </div>
    )
}